export const dateHandler = (date: number): string => {
  return `${new Date(date).toLocaleTimeString()} ${new Date(date).toLocaleDateString()}`;
};
